export default __webpack_public_path__ + "static/media/w3school-certificate.6739d3cb.png";